import { render } from "./importDialog.vue?vue&type=template&id=3bebb126&scoped=true&ts=true"
import script from "./importDialog.vue?vue&type=script&lang=ts"
export * from "./importDialog.vue?vue&type=script&lang=ts"

import "./importDialog.vue?vue&type=style&index=0&id=3bebb126&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bebb126"]])

export default __exports__